// Generated from MASTER_TABLES.md. Do not edit manually.

export const TABLE_1_DOMAIN_SEQUENCE = [
  "DIAGNOSTIC SERVICES",
  "DENTAL CLEANING",
  "RESTORATIONS",
  "EXTRACTIONS",
  "ROOT CANAL TREATMENT",
  "CROWNS",
  "BRIDGES",
  "DENTURES",
  "ORTHODONTICS",
  "COSMETIC DENTISTRY",
  "IMPLANTS",
  "PEDIATRIC DENTISTRY",
  "GUM TREATMENT",
  "ORAL SURGERY",
  "MOUTHGUARDS"
];

export const TABLE_1_TREATMENTS = [
  {
    "domain": "DIAGNOSTIC SERVICES",
    "name": "Oral Examination / Consultation"
  },
  {
    "domain": "DIAGNOSTIC SERVICES",
    "name": "Digital X-Ray (IOPA)"
  },
  {
    "domain": "DIAGNOSTIC SERVICES",
    "name": "Full Mouth X-Ray (OPG)"
  },
  {
    "domain": "DIAGNOSTIC SERVICES",
    "name": "Diagnostic Review / Follow-up"
  },
  {
    "domain": "DENTAL CLEANING",
    "name": "Dental Cleaning - Scaling Grade I"
  },
  {
    "domain": "DENTAL CLEANING",
    "name": "Dental Cleaning - Scaling Grade II"
  },
  {
    "domain": "DENTAL CLEANING",
    "name": "Dental Cleaning - Scaling Grade III"
  },
  {
    "domain": "DENTAL CLEANING",
    "name": "Dental Cleaning - Curettage"
  },
  {
    "domain": "DENTAL CLEANING",
    "name": "Dental Cleaning - Polishing"
  },
  {
    "domain": "RESTORATIONS",
    "name": "Restoration - GIC"
  },
  {
    "domain": "RESTORATIONS",
    "name": "Restoration - Tooth Coloured Composite"
  },
  {
    "domain": "RESTORATIONS",
    "name": "Restoration - Tooth Coloured Composite (Best Quality)"
  },
  {
    "domain": "RESTORATIONS",
    "name": "Restoration - Crown re-cementation"
  },
  {
    "domain": "RESTORATIONS",
    "name": "Restoration - Indirect Pulp Capping"
  },
  {
    "domain": "EXTRACTIONS",
    "name": "Tooth Extraction - Anterior"
  },
  {
    "domain": "EXTRACTIONS",
    "name": "Tooth Extraction - Posterior"
  },
  {
    "domain": "EXTRACTIONS",
    "name": "Tooth Extraction - 3rd molar - Surgical"
  },
  {
    "domain": "EXTRACTIONS",
    "name": "Tooth Extraction - 3rd molar - Non Surgical"
  },
  {
    "domain": "ROOT CANAL TREATMENT",
    "name": "Root Canal Treatment - Anterior Tooth"
  },
  {
    "domain": "ROOT CANAL TREATMENT",
    "name": "Root Canal Treatment - Posterior Tooth"
  },
  {
    "domain": "ROOT CANAL TREATMENT",
    "name": "Root Canal Treatment - Re-RCT"
  },
  {
    "domain": "ROOT CANAL TREATMENT",
    "name": "Post and Core"
  },
  {
    "domain": "CROWNS",
    "name": "Crown - Metal"
  },
  {
    "domain": "CROWNS",
    "name": "Crown - PFM (5 years Warranty)"
  },
  {
    "domain": "CROWNS",
    "name": "Crown - PFM (10 years Warranty)"
  },
  {
    "domain": "CROWNS",
    "name": "Crown - Ceramic"
  },
  {
    "domain": "CROWNS",
    "name": "Crown - Zirconia (Standard - 5 years warranty)"
  },
  {
    "domain": "CROWNS",
    "name": "Crown - Zirconia (Premium - 10 years warranty)"
  },
  {
    "domain": "CROWNS",
    "name": "Crown - Zirconia (Premium - 15 years warranty)"
  },
  {
    "domain": "BRIDGES",
    "name": "Bridge - 3 Unit PFM"
  },
  {
    "domain": "BRIDGES",
    "name": "Bridge - 3 Unit Zirconia"
  },
  {
    "domain": "BRIDGES",
    "name": "Bridge - 4+ Unit Zirconia"
  },
  {
    "domain": "DENTURES",
    "name": "Dentures - Complete Denture (Upper)"
  },
  {
    "domain": "DENTURES",
    "name": "Dentures - Complete Denture (Lower)"
  },
  {
    "domain": "DENTURES",
    "name": "Dentures - Partial Denture"
  },
  {
    "domain": "DENTURES",
    "name": "Dentures - Flexible Denture"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Braces - Metal Braces"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Braces - Ceramic Braces"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Braces - Self-Ligating Braces"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Braces - Damon Braces"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Clear Aligners - Basic Package"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Clear Aligners - Premium Package"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Clear Aligners - Invisalign (Full Case)"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Retainers - Removable Retainer (Single Arch)"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Retainers - Fixed Retainer (Single Arch)"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Retainers - Clear Retainer (Single Arch)"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Smile Design - Composite Bonding"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Smile Design - Diastema Closure"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Smile Design - Veneers (E-max)"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Smile Design - Veneers (CAD-CAM 3D Printed)"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Smile Design - Tooth Contouring"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Teeth Whitening - In-Clinic Whitening"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Teeth Whitening - Home Whitening Kit"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Tooth Jewelry - Crystal Application"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Tooth Jewelry - Gold / Diamond Custom Design"
  },
  {
    "domain": "IMPLANTS",
    "name": "Implants - Single Tooth Implant (Standard)"
  },
  {
    "domain": "IMPLANTS",
    "name": "Implants - Single Tooth Implant (Premium)"
  },
  {
    "domain": "IMPLANTS",
    "name": "Implants - Full Mouth Implants (Upper Arch)"
  },
  {
    "domain": "IMPLANTS",
    "name": "Implants - Full Mouth Implants (Lower Arch)"
  },
  {
    "domain": "IMPLANTS",
    "name": "Implants - Implant-Supported Denture"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Pediatric Dentistry - Consultation"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Pediatric Dentistry - Fluoride Application"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Pediatric Dentistry - Pit & Fissure Sealant"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Pediatric Dentistry - Pulpotomy"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Pediatric Dentistry - Stainless Steel Crown"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Pediatric Dentistry - Extraction (Milk Tooth)"
  },
  {
    "domain": "GUM TREATMENT",
    "name": "Gum Treatment - Gingivitis Cleaning"
  },
  {
    "domain": "GUM TREATMENT",
    "name": "Gum Treatment - Curettage (Deep Cleaning)"
  },
  {
    "domain": "GUM TREATMENT",
    "name": "Gum Treatment - Flap Surgery"
  },
  {
    "domain": "GUM TREATMENT",
    "name": "Gum Treatment - Gummy Smile Correction"
  },
  {
    "domain": "ORAL SURGERY",
    "name": "Oral Surgery - Biopsy"
  },
  {
    "domain": "ORAL SURGERY",
    "name": "Oral Surgery - Frenectomy"
  },
  {
    "domain": "ORAL SURGERY",
    "name": "Oral Surgery - Incision & Drainage"
  },
  {
    "domain": "ORAL SURGERY",
    "name": "Oral Surgery - Alveoloplasty"
  },
  {
    "domain": "MOUTHGUARDS",
    "name": "Mouthguards - Night Guard for Bruxism"
  },
  {
    "domain": "MOUTHGUARDS",
    "name": "Mouthguards - Sports Guard"
  },
  {
    "domain": "MOUTHGUARDS",
    "name": "Mouthguards - TMJ Splint"
  }
];

export const TABLE_1_TREATMENTS_BY_DOMAIN = {
  "DIAGNOSTIC SERVICES": [
    {
      "domain": "DIAGNOSTIC SERVICES",
      "name": "Oral Examination / Consultation"
    },
    {
      "domain": "DIAGNOSTIC SERVICES",
      "name": "Digital X-Ray (IOPA)"
    },
    {
      "domain": "DIAGNOSTIC SERVICES",
      "name": "Full Mouth X-Ray (OPG)"
    },
    {
      "domain": "DIAGNOSTIC SERVICES",
      "name": "Diagnostic Review / Follow-up"
    }
  ],
  "DENTAL CLEANING": [
    {
      "domain": "DENTAL CLEANING",
      "name": "Dental Cleaning - Scaling Grade I"
    },
    {
      "domain": "DENTAL CLEANING",
      "name": "Dental Cleaning - Scaling Grade II"
    },
    {
      "domain": "DENTAL CLEANING",
      "name": "Dental Cleaning - Scaling Grade III"
    },
    {
      "domain": "DENTAL CLEANING",
      "name": "Dental Cleaning - Curettage"
    },
    {
      "domain": "DENTAL CLEANING",
      "name": "Dental Cleaning - Polishing"
    }
  ],
  "RESTORATIONS": [
    {
      "domain": "RESTORATIONS",
      "name": "Restoration - GIC"
    },
    {
      "domain": "RESTORATIONS",
      "name": "Restoration - Tooth Coloured Composite"
    },
    {
      "domain": "RESTORATIONS",
      "name": "Restoration - Tooth Coloured Composite (Best Quality)"
    },
    {
      "domain": "RESTORATIONS",
      "name": "Restoration - Crown re-cementation"
    },
    {
      "domain": "RESTORATIONS",
      "name": "Restoration - Indirect Pulp Capping"
    }
  ],
  "EXTRACTIONS": [
    {
      "domain": "EXTRACTIONS",
      "name": "Tooth Extraction - Anterior"
    },
    {
      "domain": "EXTRACTIONS",
      "name": "Tooth Extraction - Posterior"
    },
    {
      "domain": "EXTRACTIONS",
      "name": "Tooth Extraction - 3rd molar - Surgical"
    },
    {
      "domain": "EXTRACTIONS",
      "name": "Tooth Extraction - 3rd molar - Non Surgical"
    }
  ],
  "ROOT CANAL TREATMENT": [
    {
      "domain": "ROOT CANAL TREATMENT",
      "name": "Root Canal Treatment - Anterior Tooth"
    },
    {
      "domain": "ROOT CANAL TREATMENT",
      "name": "Root Canal Treatment - Posterior Tooth"
    },
    {
      "domain": "ROOT CANAL TREATMENT",
      "name": "Root Canal Treatment - Re-RCT"
    },
    {
      "domain": "ROOT CANAL TREATMENT",
      "name": "Post and Core"
    }
  ],
  "CROWNS": [
    {
      "domain": "CROWNS",
      "name": "Crown - Metal"
    },
    {
      "domain": "CROWNS",
      "name": "Crown - PFM (5 years Warranty)"
    },
    {
      "domain": "CROWNS",
      "name": "Crown - PFM (10 years Warranty)"
    },
    {
      "domain": "CROWNS",
      "name": "Crown - Ceramic"
    },
    {
      "domain": "CROWNS",
      "name": "Crown - Zirconia (Standard - 5 years warranty)"
    },
    {
      "domain": "CROWNS",
      "name": "Crown - Zirconia (Premium - 10 years warranty)"
    },
    {
      "domain": "CROWNS",
      "name": "Crown - Zirconia (Premium - 15 years warranty)"
    }
  ],
  "BRIDGES": [
    {
      "domain": "BRIDGES",
      "name": "Bridge - 3 Unit PFM"
    },
    {
      "domain": "BRIDGES",
      "name": "Bridge - 3 Unit Zirconia"
    },
    {
      "domain": "BRIDGES",
      "name": "Bridge - 4+ Unit Zirconia"
    }
  ],
  "DENTURES": [
    {
      "domain": "DENTURES",
      "name": "Dentures - Complete Denture (Upper)"
    },
    {
      "domain": "DENTURES",
      "name": "Dentures - Complete Denture (Lower)"
    },
    {
      "domain": "DENTURES",
      "name": "Dentures - Partial Denture"
    },
    {
      "domain": "DENTURES",
      "name": "Dentures - Flexible Denture"
    }
  ],
  "ORTHODONTICS": [
    {
      "domain": "ORTHODONTICS",
      "name": "Braces - Metal Braces"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Braces - Ceramic Braces"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Braces - Self-Ligating Braces"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Braces - Damon Braces"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Clear Aligners - Basic Package"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Clear Aligners - Premium Package"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Clear Aligners - Invisalign (Full Case)"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Retainers - Removable Retainer (Single Arch)"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Retainers - Fixed Retainer (Single Arch)"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Retainers - Clear Retainer (Single Arch)"
    }
  ],
  "COSMETIC DENTISTRY": [
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Smile Design - Composite Bonding"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Smile Design - Diastema Closure"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Smile Design - Veneers (E-max)"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Smile Design - Veneers (CAD-CAM 3D Printed)"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Smile Design - Tooth Contouring"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Teeth Whitening - In-Clinic Whitening"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Teeth Whitening - Home Whitening Kit"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Tooth Jewelry - Crystal Application"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Tooth Jewelry - Gold / Diamond Custom Design"
    }
  ],
  "IMPLANTS": [
    {
      "domain": "IMPLANTS",
      "name": "Implants - Single Tooth Implant (Standard)"
    },
    {
      "domain": "IMPLANTS",
      "name": "Implants - Single Tooth Implant (Premium)"
    },
    {
      "domain": "IMPLANTS",
      "name": "Implants - Full Mouth Implants (Upper Arch)"
    },
    {
      "domain": "IMPLANTS",
      "name": "Implants - Full Mouth Implants (Lower Arch)"
    },
    {
      "domain": "IMPLANTS",
      "name": "Implants - Implant-Supported Denture"
    }
  ],
  "PEDIATRIC DENTISTRY": [
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Pediatric Dentistry - Consultation"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Pediatric Dentistry - Fluoride Application"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Pediatric Dentistry - Pit & Fissure Sealant"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Pediatric Dentistry - Pulpotomy"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Pediatric Dentistry - Stainless Steel Crown"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Pediatric Dentistry - Extraction (Milk Tooth)"
    }
  ],
  "GUM TREATMENT": [
    {
      "domain": "GUM TREATMENT",
      "name": "Gum Treatment - Gingivitis Cleaning"
    },
    {
      "domain": "GUM TREATMENT",
      "name": "Gum Treatment - Curettage (Deep Cleaning)"
    },
    {
      "domain": "GUM TREATMENT",
      "name": "Gum Treatment - Flap Surgery"
    },
    {
      "domain": "GUM TREATMENT",
      "name": "Gum Treatment - Gummy Smile Correction"
    }
  ],
  "ORAL SURGERY": [
    {
      "domain": "ORAL SURGERY",
      "name": "Oral Surgery - Biopsy"
    },
    {
      "domain": "ORAL SURGERY",
      "name": "Oral Surgery - Frenectomy"
    },
    {
      "domain": "ORAL SURGERY",
      "name": "Oral Surgery - Incision & Drainage"
    },
    {
      "domain": "ORAL SURGERY",
      "name": "Oral Surgery - Alveoloplasty"
    }
  ],
  "MOUTHGUARDS": [
    {
      "domain": "MOUTHGUARDS",
      "name": "Mouthguards - Night Guard for Bruxism"
    },
    {
      "domain": "MOUTHGUARDS",
      "name": "Mouthguards - Sports Guard"
    },
    {
      "domain": "MOUTHGUARDS",
      "name": "Mouthguards - TMJ Splint"
    }
  ]
};

export const TABLE_2_DOMAIN_SEQUENCE = [
  "COMMON CONSUMABLES",
  "DIAGNOSTIC & RADIOLOGY",
  "PERIODONTICS / SCALING",
  "CONSERVATIVE DENTISTRY / RESTORATIONS",
  "ENDODONTICS / ROOT CANAL",
  "ORAL SURGERY / EXTRACTIONS",
  "PROSTHODONTICS / CROWNS & DENTURES",
  "ORTHODONTICS",
  "COSMETIC DENTISTRY",
  "IMPLANTOLOGY",
  "PEDIATRIC DENTISTRY"
];

export const TABLE_2_INVENTORY_ITEMS = [
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Gloves",
    "typeVariant": "Small",
    "unit": "Pair"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Gloves",
    "typeVariant": "Medium",
    "unit": "Pair"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Gloves",
    "typeVariant": "Large",
    "unit": "Pair"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Face Mask",
    "typeVariant": "With Visor",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Face Mask",
    "typeVariant": "Without Visor",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Head Cap",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Patient Bib",
    "typeVariant": "Adult",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Patient Bib",
    "typeVariant": "Child",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Suction Tip",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Suction Tip",
    "typeVariant": "Surgical",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Surface Disinfectant",
    "typeVariant": "Liquid",
    "unit": "ml"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Surface Disinfectant",
    "typeVariant": "Wipes",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Gauze 2x2",
    "typeVariant": "Sterile",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Sterile Gauze 4x4",
    "typeVariant": "Plied",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Cotton Rolls",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Chlorhexidine mouthwash",
    "typeVariant": "0.12%",
    "unit": "ml"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Chlorhexidine mouthwash",
    "typeVariant": "0.20%",
    "unit": "ml"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Distilled Water",
    "typeVariant": "500ml",
    "unit": "Bottle"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Articulating Paper",
    "typeVariant": "Thin",
    "unit": "Strip"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Articulating Paper",
    "typeVariant": "Thick",
    "unit": "Strip"
  },
  {
    "domain": "COMMON CONSUMABLES",
    "name": "Disinfectant Wipe",
    "typeVariant": "Headrest",
    "unit": "Piece"
  },
  {
    "domain": "DIAGNOSTIC & RADIOLOGY",
    "name": "IOPA Sensor Sleeve",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "DIAGNOSTIC & RADIOLOGY",
    "name": "Phosphor Plate Sleeve",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "DIAGNOSTIC & RADIOLOGY",
    "name": "OPG Protective Collar",
    "typeVariant": "Disposable",
    "unit": "Piece"
  },
  {
    "domain": "DIAGNOSTIC & RADIOLOGY",
    "name": "Lead Apron",
    "typeVariant": "Adult",
    "unit": "Use"
  },
  {
    "domain": "DIAGNOSTIC & RADIOLOGY",
    "name": "Lead Apron",
    "typeVariant": "Child",
    "unit": "Use"
  },
  {
    "domain": "DIAGNOSTIC & RADIOLOGY",
    "name": "Mouth Mirror",
    "typeVariant": "Single Use",
    "unit": "Piece"
  },
  {
    "domain": "DIAGNOSTIC & RADIOLOGY",
    "name": "Periodontal Probe",
    "typeVariant": "Disposable",
    "unit": "Piece"
  },
  {
    "domain": "DIAGNOSTIC & RADIOLOGY",
    "name": "Tongue Depressor",
    "typeVariant": "Wooden",
    "unit": "Piece"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Ultrasonic Scaler Tip",
    "typeVariant": "Universal",
    "unit": "Piece"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Ultrasonic Scaler Tip",
    "typeVariant": "Perio",
    "unit": "Piece"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Prophy Paste",
    "typeVariant": "Fine Grit",
    "unit": "gram"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Prophy Paste",
    "typeVariant": "Coarse Grit",
    "unit": "gram"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Prophy Paste",
    "typeVariant": "Fluoridated",
    "unit": "gram"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Polishing Cup",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Polishing Brush",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Curette",
    "typeVariant": "Gracey 1/2",
    "unit": "Piece"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Curette",
    "typeVariant": "Gracey 13/14",
    "unit": "Piece"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Curette",
    "typeVariant": "Surgical",
    "unit": "Piece"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Fluoride Varnish",
    "typeVariant": "5% NaF",
    "unit": "ml"
  },
  {
    "domain": "PERIODONTICS / SCALING",
    "name": "Disposable Brush",
    "typeVariant": "Foam",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "GIC Powder",
    "typeVariant": "Type II",
    "unit": "gram"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "GIC Liquid",
    "typeVariant": "Type II",
    "unit": "ml"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Mixing Pad",
    "typeVariant": "Paper",
    "unit": "Sheet"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Plastic Filling Instrument",
    "typeVariant": "Double Ended",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Matrix Band",
    "typeVariant": "Universal",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Wooden Wedge",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Bonding Agent",
    "typeVariant": "5th Generation",
    "unit": "ml"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Bonding Agent",
    "typeVariant": "7th Generation",
    "unit": "ml"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Etchant Gel",
    "typeVariant": "37% Phosphoric Acid",
    "unit": "ml"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Material",
    "typeVariant": "A1",
    "unit": "gram"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Material",
    "typeVariant": "A2",
    "unit": "gram"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Material",
    "typeVariant": "A3",
    "unit": "gram"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Material",
    "typeVariant": "A3.5",
    "unit": "gram"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Material",
    "typeVariant": "B1",
    "unit": "gram"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Material",
    "typeVariant": "B2",
    "unit": "gram"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Material",
    "typeVariant": "C2",
    "unit": "gram"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Material",
    "typeVariant": "Clear",
    "unit": "gram"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Material",
    "typeVariant": "Opaque",
    "unit": "gram"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Dispensing Tip",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Composite Dispensing Tip",
    "typeVariant": "Centrix",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Sectional Matrix",
    "typeVariant": "Contact Pro",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Matrix Retainer",
    "typeVariant": "Tofflemire",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Wedge",
    "typeVariant": "Wooden",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Wedge",
    "typeVariant": "Plastic",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Finishing Strip",
    "typeVariant": "Fine",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Finishing Strip",
    "typeVariant": "Coarse",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Polishing Point",
    "typeVariant": "Composite",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Polishing Point",
    "typeVariant": "Enamel",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Diamond Bur",
    "typeVariant": "Round FG",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Diamond Bur",
    "typeVariant": "Pear FG",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Diamond Bur",
    "typeVariant": "Flame FG",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Diamond Bur",
    "typeVariant": "Tapered FG",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Carbide Bur",
    "typeVariant": "Round FG",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Carbide Bur",
    "typeVariant": "Inverted Cone FG",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Carbide Bur",
    "typeVariant": "Fissure FG",
    "unit": "Piece"
  },
  {
    "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
    "name": "Carbide Bur",
    "typeVariant": "Pear FG",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Rubber Dam Sheet",
    "typeVariant": "Non-Latex",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Rubber Dam Sheet",
    "typeVariant": "Latex",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Rubber Dam Clamp",
    "typeVariant": "Anterior",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Rubber Dam Clamp",
    "typeVariant": "Molar",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Rubber Dam Frame",
    "typeVariant": "Plastic",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Rubber Dam Frame",
    "typeVariant": "Metal",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Local Anaesthetic Cartridge",
    "typeVariant": "Lignocaine 2%",
    "unit": "Cartridge"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Local Anaesthetic Cartridge",
    "typeVariant": "Articaine 4%",
    "unit": "Cartridge"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Needle",
    "typeVariant": "27G Long",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Needle",
    "typeVariant": "30G Short",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Sodium Hypochlorite",
    "typeVariant": "3.00%",
    "unit": "ml"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Sodium Hypochlorite",
    "typeVariant": "5.25%",
    "unit": "ml"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "EDTA Gel",
    "typeVariant": "17.00%",
    "unit": "ml"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "EDTA Solution",
    "typeVariant": "17.00%",
    "unit": "ml"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Saline Solution",
    "typeVariant": "Irrigation",
    "unit": "ml"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Paper Points",
    "typeVariant": "Size 20",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Paper Points",
    "typeVariant": "Size 25",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Paper Points",
    "typeVariant": "Size 30",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Paper Points",
    "typeVariant": "Size 35",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Paper Points",
    "typeVariant": "Size 40",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gutta Percha Points",
    "typeVariant": "Size 20",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gutta Percha Points",
    "typeVariant": "Size 25",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gutta Percha Points",
    "typeVariant": "Size 30",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gutta Percha Points",
    "typeVariant": "Size 35",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gutta Percha Points",
    "typeVariant": "Size 40",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Endo File Rotary",
    "typeVariant": ".04 Taper",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Endo File Rotary",
    "typeVariant": ".06 Taper",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Endo File Hand",
    "typeVariant": "K-File",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Endo File Hand",
    "typeVariant": "H-File",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Root Canal Sealer",
    "typeVariant": "Epoxy",
    "unit": "ml"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Root Canal Sealer",
    "typeVariant": "Silicone",
    "unit": "ml"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Temporary Filling",
    "typeVariant": "Cavit G",
    "unit": "gram"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Solvent",
    "typeVariant": "Chloroform",
    "unit": "ml"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Solvent",
    "typeVariant": "Endo Solvent R",
    "unit": "ml"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Retreatment Files",
    "typeVariant": "Special",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Post System",
    "typeVariant": "Fiber",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Post System",
    "typeVariant": "Metal",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Core Build-up Material",
    "typeVariant": "Opaque",
    "unit": "gram"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gates Glidden Drill",
    "typeVariant": "Size 1",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gates Glidden Drill",
    "typeVariant": "Size 2",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gates Glidden Drill",
    "typeVariant": "Size 3",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gates Glidden Drill",
    "typeVariant": "Size 4",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gates Glidden Drill",
    "typeVariant": "Size 5",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Gates Glidden Drill",
    "typeVariant": "Size 6",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Peeso Reamer",
    "typeVariant": "Size 1",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Peeso Reamer",
    "typeVariant": "Size 2",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Peeso Reamer",
    "typeVariant": "Size 3",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Peeso Reamer",
    "typeVariant": "Size 4",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Peeso Reamer",
    "typeVariant": "Size 5",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Peeso Reamer",
    "typeVariant": "Size 6",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Apex Locator Sleeve",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ENDODONTICS / ROOT CANAL",
    "name": "Endo Block",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Sterile Gloves",
    "typeVariant": "Large",
    "unit": "Pair"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Sutures",
    "typeVariant": "3-0 PGA",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Sutures",
    "typeVariant": "4-0 PGA",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Sutures",
    "typeVariant": "3-0 Silk",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Elevator",
    "typeVariant": "Straight",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Elevator",
    "typeVariant": "Cryer",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Elevator",
    "typeVariant": "Potts",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Extraction Forceps",
    "typeVariant": "Universal Upper",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Extraction Forceps",
    "typeVariant": "Universal Lower",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Extraction Forceps",
    "typeVariant": "Anterior",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Extraction Forceps",
    "typeVariant": "Molar",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Gauze Pack",
    "typeVariant": "Pressure Dressing",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Betadine Solution",
    "typeVariant": "Standard",
    "unit": "ml"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Sterile Drapes",
    "typeVariant": "Small",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Sterile Drapes",
    "typeVariant": "Large",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Scalpel Blade",
    "typeVariant": "No. 15",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Scalpel Blade",
    "typeVariant": "No. 15C",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Surgical Suction Tip",
    "typeVariant": "Frazier",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Sterile Saline",
    "typeVariant": "50 mL",
    "unit": "Bottle"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Sterile Saline",
    "typeVariant": "100 mL",
    "unit": "Bottle"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Bone Graft",
    "typeVariant": "Bio-Oss",
    "unit": "gram"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Bone Graft",
    "typeVariant": "Hydroxyapatite",
    "unit": "gram"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Membrane",
    "typeVariant": "Collagen",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Membrane",
    "typeVariant": "PTFE",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Biopsy Container",
    "typeVariant": "With Formalin",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Surgical Stent",
    "typeVariant": "Custom",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Drain",
    "typeVariant": "Penrose",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Bone File",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Rongeur",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Chisel",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORAL SURGERY / EXTRACTIONS",
    "name": "Mallet",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Alginate Powder",
    "typeVariant": "Fast Set",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Alginate Powder",
    "typeVariant": "Regular Set",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Elastomeric Light Body",
    "typeVariant": "Polyvinyl Siloxane",
    "unit": "ml"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Elastomeric Light Body",
    "typeVariant": "Polyether",
    "unit": "ml"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Elastomeric Putty",
    "typeVariant": "Regular",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Tray Adhesive",
    "typeVariant": "For PVS",
    "unit": "ml"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Tray Adhesive",
    "typeVariant": "For Polyether",
    "unit": "ml"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Bite Registration Paste",
    "typeVariant": "Hard",
    "unit": "ml"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Bite Registration Paste",
    "typeVariant": "Soft",
    "unit": "ml"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Temporary Crown Material",
    "typeVariant": "Auto-mix",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Temporary Crown Material",
    "typeVariant": "Hand-mix",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Crown Cement",
    "typeVariant": "Resin-Modified GIC",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Crown Cement",
    "typeVariant": "Self-Adhesive Resin",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Disposable Crown Seat Syringe Tip",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Bridge Cement",
    "typeVariant": "Resin-Modified GIC",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Bridge Cement",
    "typeVariant": "Self-Adhesive Resin",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Denture Base Resin",
    "typeVariant": "Heat Cure",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Denture Base Resin",
    "typeVariant": "Cold Cure",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Acrylic Teeth",
    "typeVariant": "Anterior Set",
    "unit": "Set"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Acrylic Teeth",
    "typeVariant": "Posterior Set",
    "unit": "Set"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Pressure Indicating Paste",
    "typeVariant": "Standard",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Flexible Denture Material",
    "typeVariant": "Nylon-Based",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Wax Bite Rim",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Face Bow Transfer Kit",
    "typeVariant": "Disposable",
    "unit": "Kit"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Occlusal Indicator Wax",
    "typeVariant": "Standard",
    "unit": "gram"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Denture Cleaning Tablets",
    "typeVariant": "Standard",
    "unit": "Tablet"
  },
  {
    "domain": "PROSTHODONTICS / CROWNS & DENTURES",
    "name": "Denture Repair Kit",
    "typeVariant": "Standard",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Metal Brackets Kit",
    "typeVariant": "MBT 0.22",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Metal Brackets Kit",
    "typeVariant": "Roth 0.22",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Metal Brackets Kit",
    "typeVariant": "Standard 0.22",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Ceramic Brackets Kit",
    "typeVariant": "Clear 0.22",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Ceramic Brackets Kit",
    "typeVariant": "Sapphire 0.22",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Self-Ligating Brackets Kit",
    "typeVariant": "Damon Q",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Self-Ligating Brackets Kit",
    "typeVariant": "Damon Clear",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Self-Ligating Brackets Kit",
    "typeVariant": "In-Ovation R",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Self-Ligating Brackets Kit",
    "typeVariant": "SmartClip",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Self-Ligating Brackets Kit",
    "typeVariant": "Quick",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Lingual Brackets Kit",
    "typeVariant": "Incognito",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Lingual Brackets Kit",
    "typeVariant": "STb",
    "unit": "Kit"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Functional Appliances",
    "typeVariant": "Twin Block",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Functional Appliances",
    "typeVariant": "Frankel",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Functional Appliances",
    "typeVariant": "Bionator",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Upper",
    "typeVariant": "Round 0.012",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Upper",
    "typeVariant": "Round 0.014",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Upper",
    "typeVariant": "Round 0.016",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Upper",
    "typeVariant": "Round 0.018",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Upper",
    "typeVariant": "Rectangular 0.016x0.022",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Upper",
    "typeVariant": "Rectangular 0.017x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Upper",
    "typeVariant": "Rectangular 0.019x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Lower",
    "typeVariant": "Round 0.012",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Lower",
    "typeVariant": "Round 0.014",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Lower",
    "typeVariant": "Round 0.016",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Lower",
    "typeVariant": "Round 0.018",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Lower",
    "typeVariant": "Rectangular 0.016x0.022",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Lower",
    "typeVariant": "Rectangular 0.017x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nickel Titanium Archwire Lower",
    "typeVariant": "Rectangular 0.019x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Upper",
    "typeVariant": "Round 0.016",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Upper",
    "typeVariant": "Round 0.018",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Upper",
    "typeVariant": "Round 0.020",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Upper",
    "typeVariant": "Rectangular 0.016x0.022",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Upper",
    "typeVariant": "Rectangular 0.017x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Upper",
    "typeVariant": "Rectangular 0.019x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Lower",
    "typeVariant": "Round 0.016",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Lower",
    "typeVariant": "Round 0.018",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Lower",
    "typeVariant": "Round 0.020",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Lower",
    "typeVariant": "Rectangular 0.016x0.022",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Lower",
    "typeVariant": "Rectangular 0.017x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Archwire Lower",
    "typeVariant": "Rectangular 0.019x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Beta Titanium Archwire (TMA) Upper",
    "typeVariant": "Round 0.016",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Beta Titanium Archwire (TMA) Upper",
    "typeVariant": "Round 0.018",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Beta Titanium Archwire (TMA) Upper",
    "typeVariant": "Rectangular 0.017x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Beta Titanium Archwire (TMA) Upper",
    "typeVariant": "Rectangular 0.019x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Beta Titanium Archwire (TMA) Lower",
    "typeVariant": "Round 0.016",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Beta Titanium Archwire (TMA) Lower",
    "typeVariant": "Round 0.018",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Beta Titanium Archwire (TMA) Lower",
    "typeVariant": "Rectangular 0.017x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Beta Titanium Archwire (TMA) Lower",
    "typeVariant": "Rectangular 0.019x0.025",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Copper NiTi Archwire Upper",
    "typeVariant": "0.012",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Copper NiTi Archwire Upper",
    "typeVariant": "0.014",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Copper NiTi Archwire Upper",
    "typeVariant": "0.016",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Copper NiTi Archwire Upper",
    "typeVariant": "0.018",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Copper NiTi Archwire Lower",
    "typeVariant": "0.012",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Copper NiTi Archwire Lower",
    "typeVariant": "0.014",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Copper NiTi Archwire Lower",
    "typeVariant": "0.016",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Copper NiTi Archwire Lower",
    "typeVariant": "0.018",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Elastic Modules",
    "typeVariant": "Grey",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Elastic Modules",
    "typeVariant": "Clear",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Elastic Modules",
    "typeVariant": "Silver",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Elastic Modules",
    "typeVariant": "Colored Assorted",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Ligatures",
    "typeVariant": "Short",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Ligatures",
    "typeVariant": "Medium",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Stainless Steel Ligatures",
    "typeVariant": "Long",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Power Chains",
    "typeVariant": "Short Continuous",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Power Chains",
    "typeVariant": "Medium Continuous",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Power Chains",
    "typeVariant": "Long Continuous",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Separators",
    "typeVariant": "Elastic",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Separators",
    "typeVariant": "Brass Wire",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Separator Pliers",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Mathieu Pliers",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Weingart Pliers",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Light Wire Pliers",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Bird Beak Pliers",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Howe Pliers",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Distal End Cutter",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Bracket Removing Pliers",
    "typeVariant": "Straight",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Bracket Removing Pliers",
    "typeVariant": "Curved",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Band Removing Pliers",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Molar Bands",
    "typeVariant": "Assorted Sizes",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Molar Bands",
    "typeVariant": "Upper First Molar",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Molar Bands",
    "typeVariant": "Lower First Molar",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Molar Bands",
    "typeVariant": "Upper Second Molar",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Molar Bands",
    "typeVariant": "Lower Second Molar",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Buccal Tubes",
    "typeVariant": "Single",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Buccal Tubes",
    "typeVariant": "Double",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Buccal Tubes",
    "typeVariant": "Triple",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Lingual Buttons",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Lingual Buttons",
    "typeVariant": "Double",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Lingual Buttons",
    "typeVariant": "Mesh Base",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Band Cement",
    "typeVariant": "Glass Ionomer",
    "unit": "gram"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Band Cement",
    "typeVariant": "Resin Modified",
    "unit": "gram"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Orthodontic Bonding Adhesive",
    "typeVariant": "Chemical Cure",
    "unit": "ml"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Orthodontic Bonding Adhesive",
    "typeVariant": "Light Cure",
    "unit": "ml"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Orthodontic Primer",
    "typeVariant": "Standard",
    "unit": "ml"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Orthodontic Primer",
    "typeVariant": "Self-Etching",
    "unit": "ml"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Orthodontic Etchant",
    "typeVariant": "37% Phosphoric Acid",
    "unit": "ml"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Bracket Adhesive Paste",
    "typeVariant": "Standard",
    "unit": "ml"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Bracket Adhesive Paste",
    "typeVariant": "High Strength",
    "unit": "ml"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Debonding Bur",
    "typeVariant": "Tungsten Carbide",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Debonding Bur",
    "typeVariant": "Diamond",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Adhesive Remover",
    "typeVariant": "Standard",
    "unit": "ml"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Adhesive Remover",
    "typeVariant": "Fluoridated",
    "unit": "ml"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Interarch Elastics",
    "typeVariant": "Light 1/8\"",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Interarch Elastics",
    "typeVariant": "Medium 3/16\"",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Interarch Elastics",
    "typeVariant": "Heavy 1/4\"",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Interarch Elastics",
    "typeVariant": "Class II",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Interarch Elastics",
    "typeVariant": "Class III",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Interarch Elastics",
    "typeVariant": "Vertical",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Coil Springs",
    "typeVariant": "Open 9mm",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Coil Springs",
    "typeVariant": "Open 12mm",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Coil Springs",
    "typeVariant": "Closed 9mm",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Coil Springs",
    "typeVariant": "Closed 12mm",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Push Springs",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Pull Springs",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Ligature Director",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Ligature Cutter",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Clear Aligner Trays",
    "typeVariant": "Basic Package",
    "unit": "Set"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Clear Aligner Trays",
    "typeVariant": "Premium Package",
    "unit": "Set"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Clear Aligner Trays",
    "typeVariant": "Invisalign Full",
    "unit": "Set"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Attachment Templates",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Attachment Templates",
    "typeVariant": "Premium",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Attachment Composite",
    "typeVariant": "Standard",
    "unit": "gram"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Attachment Composite",
    "typeVariant": "High Strength",
    "unit": "gram"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Chewies",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Aligner Case",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Aligner Cleaning Crystals",
    "typeVariant": "Standard",
    "unit": "gram"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Aligner Removal Tool",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Hawley Retainer",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Hawley Retainer",
    "typeVariant": "With Acrylic",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Clear Retainer",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Clear Retainer",
    "typeVariant": "Premium",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Fixed Retainer Wire",
    "typeVariant": "Braided 0.0175",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Fixed Retainer Wire",
    "typeVariant": "Braided 0.0215",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Fixed Retainer Wire",
    "typeVariant": "Solid 0.0175",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Fixed Retainer Bonding",
    "typeVariant": "Standard",
    "unit": "ml"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Retainer Case",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Retainer Box",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Transpalatal Arch (TPA)",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Nance Button",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Lingual Arch",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Quad Helix",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Rapid Palatal Expander",
    "typeVariant": "Hyrax",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Rapid Palatal Expander",
    "typeVariant": "Haas",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Headgear",
    "typeVariant": "Cervical",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Headgear",
    "typeVariant": "High Pull",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Headgear",
    "typeVariant": "Reverse Pull",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Face Mask",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Bite Plane",
    "typeVariant": "Anterior",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Bite Plane",
    "typeVariant": "Posterior",
    "unit": "Piece"
  },
  {
    "domain": "ORTHODONTICS",
    "name": "Positioner",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Whitening Gel",
    "typeVariant": "10% Carbamide Peroxide",
    "unit": "ml"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Whitening Gel",
    "typeVariant": "16% Carbamide Peroxide",
    "unit": "ml"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Whitening Gel",
    "typeVariant": "35% Hydrogen Peroxide",
    "unit": "ml"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Cheek Retractor",
    "typeVariant": "Disposable",
    "unit": "Piece"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Desensitizing Gel",
    "typeVariant": "Post-Op",
    "unit": "ml"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Protective Eyewear",
    "typeVariant": "Patient",
    "unit": "Piece"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Laser Protective Eyewear",
    "typeVariant": "Specific Wavelength",
    "unit": "Piece"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Whitening Gel Syringes",
    "typeVariant": "Per Arch",
    "unit": "Syringe"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Custom Tray",
    "typeVariant": "Per Arch",
    "unit": "Piece"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Instructions Leaflet",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Adhesive Resin",
    "typeVariant": "Flowable",
    "unit": "ml"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Crystal/Gem",
    "typeVariant": "Clear",
    "unit": "Piece"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Crystal/Gem",
    "typeVariant": "Color",
    "unit": "Piece"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Veneer Cement",
    "typeVariant": "Clear",
    "unit": "ml"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Veneer Cement",
    "typeVariant": "Opaque",
    "unit": "ml"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Provisional Veneer Material",
    "typeVariant": "Bis-Acryl",
    "unit": "gram"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Impression Material",
    "typeVariant": "Putty",
    "unit": "gram"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Impression Material",
    "typeVariant": "Light Body",
    "unit": "ml"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Polishing Discs",
    "typeVariant": "Coarse",
    "unit": "Piece"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Polishing Discs",
    "typeVariant": "Medium",
    "unit": "Piece"
  },
  {
    "domain": "COSMETIC DENTISTRY",
    "name": "Polishing Discs",
    "typeVariant": "Fine",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Implant",
    "typeVariant": "Standard 4.0mm",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Implant",
    "typeVariant": "Premium 4.0mm",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Healing Abutment",
    "typeVariant": "Titanium",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Cover Screw",
    "typeVariant": "Titanium",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Surgical Guide",
    "typeVariant": "Disposable",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Abutments",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Abutments",
    "typeVariant": "Premium",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Implant Surgical Kit",
    "typeVariant": "Sterile",
    "unit": "Kit"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Torque Wrench",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Healing Collar",
    "typeVariant": "Titanium",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Impression Coping",
    "typeVariant": "Open Tray",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Impression Coping",
    "typeVariant": "Closed Tray",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Lab Analog",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Surgical Stent",
    "typeVariant": "Custom",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Bone Condenser",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Depth Gauge",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "IMPLANTOLOGY",
    "name": "Tap Set",
    "typeVariant": "Standard",
    "unit": "Set"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Topical Anesthetic Gel",
    "typeVariant": "Flavored",
    "unit": "ml"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Sealant Material",
    "typeVariant": "Clear",
    "unit": "ml"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Sealant Material",
    "typeVariant": "Opaque",
    "unit": "ml"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Sealant Material",
    "typeVariant": "Fluoride Releasing",
    "unit": "ml"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Microbrush",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Pulpotomy Medicament",
    "typeVariant": "MTA",
    "unit": "gram"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Pulpotomy Medicament",
    "typeVariant": "Formocresol",
    "unit": "ml"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Stainless Steel Crown",
    "typeVariant": "Size 2",
    "unit": "Piece"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Stainless Steel Crown",
    "typeVariant": "Size 4",
    "unit": "Piece"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Stainless Steel Crown",
    "typeVariant": "Size 6",
    "unit": "Piece"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Glass Ionomer Temporary",
    "typeVariant": "Type I",
    "unit": "gram"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Cement for SSC",
    "typeVariant": "Glass Ionomer",
    "unit": "gram"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Crimping Pliers",
    "typeVariant": "Sterile",
    "unit": "Piece"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Disposable Tongue Depressor",
    "typeVariant": "Wooden",
    "unit": "Piece"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Pediatric Forceps",
    "typeVariant": "Small",
    "unit": "Piece"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Pediatric Mouth Prop",
    "typeVariant": "Standard",
    "unit": "Piece"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Behavior Management Stickers",
    "typeVariant": "Assorted",
    "unit": "Piece"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Fluoride Foam",
    "typeVariant": "Tray",
    "unit": "ml"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Space Maintainer",
    "typeVariant": "Band and Loop",
    "unit": "Piece"
  },
  {
    "domain": "PEDIATRIC DENTISTRY",
    "name": "Space Maintainer",
    "typeVariant": "Distal Shoe",
    "unit": "Piece"
  }
];

export const TABLE_2_INVENTORY_BY_DOMAIN = {
  "COMMON CONSUMABLES": [
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Gloves",
      "typeVariant": "Small",
      "unit": "Pair"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Gloves",
      "typeVariant": "Medium",
      "unit": "Pair"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Gloves",
      "typeVariant": "Large",
      "unit": "Pair"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Face Mask",
      "typeVariant": "With Visor",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Face Mask",
      "typeVariant": "Without Visor",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Head Cap",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Patient Bib",
      "typeVariant": "Adult",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Patient Bib",
      "typeVariant": "Child",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Suction Tip",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Suction Tip",
      "typeVariant": "Surgical",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Surface Disinfectant",
      "typeVariant": "Liquid",
      "unit": "ml"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Surface Disinfectant",
      "typeVariant": "Wipes",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Gauze 2x2",
      "typeVariant": "Sterile",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Sterile Gauze 4x4",
      "typeVariant": "Plied",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Cotton Rolls",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Chlorhexidine mouthwash",
      "typeVariant": "0.12%",
      "unit": "ml"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Chlorhexidine mouthwash",
      "typeVariant": "0.20%",
      "unit": "ml"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Distilled Water",
      "typeVariant": "500ml",
      "unit": "Bottle"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Articulating Paper",
      "typeVariant": "Thin",
      "unit": "Strip"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Articulating Paper",
      "typeVariant": "Thick",
      "unit": "Strip"
    },
    {
      "domain": "COMMON CONSUMABLES",
      "name": "Disinfectant Wipe",
      "typeVariant": "Headrest",
      "unit": "Piece"
    }
  ],
  "DIAGNOSTIC & RADIOLOGY": [
    {
      "domain": "DIAGNOSTIC & RADIOLOGY",
      "name": "IOPA Sensor Sleeve",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "DIAGNOSTIC & RADIOLOGY",
      "name": "Phosphor Plate Sleeve",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "DIAGNOSTIC & RADIOLOGY",
      "name": "OPG Protective Collar",
      "typeVariant": "Disposable",
      "unit": "Piece"
    },
    {
      "domain": "DIAGNOSTIC & RADIOLOGY",
      "name": "Lead Apron",
      "typeVariant": "Adult",
      "unit": "Use"
    },
    {
      "domain": "DIAGNOSTIC & RADIOLOGY",
      "name": "Lead Apron",
      "typeVariant": "Child",
      "unit": "Use"
    },
    {
      "domain": "DIAGNOSTIC & RADIOLOGY",
      "name": "Mouth Mirror",
      "typeVariant": "Single Use",
      "unit": "Piece"
    },
    {
      "domain": "DIAGNOSTIC & RADIOLOGY",
      "name": "Periodontal Probe",
      "typeVariant": "Disposable",
      "unit": "Piece"
    },
    {
      "domain": "DIAGNOSTIC & RADIOLOGY",
      "name": "Tongue Depressor",
      "typeVariant": "Wooden",
      "unit": "Piece"
    }
  ],
  "PERIODONTICS / SCALING": [
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Ultrasonic Scaler Tip",
      "typeVariant": "Universal",
      "unit": "Piece"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Ultrasonic Scaler Tip",
      "typeVariant": "Perio",
      "unit": "Piece"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Prophy Paste",
      "typeVariant": "Fine Grit",
      "unit": "gram"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Prophy Paste",
      "typeVariant": "Coarse Grit",
      "unit": "gram"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Prophy Paste",
      "typeVariant": "Fluoridated",
      "unit": "gram"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Polishing Cup",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Polishing Brush",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Curette",
      "typeVariant": "Gracey 1/2",
      "unit": "Piece"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Curette",
      "typeVariant": "Gracey 13/14",
      "unit": "Piece"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Curette",
      "typeVariant": "Surgical",
      "unit": "Piece"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Fluoride Varnish",
      "typeVariant": "5% NaF",
      "unit": "ml"
    },
    {
      "domain": "PERIODONTICS / SCALING",
      "name": "Disposable Brush",
      "typeVariant": "Foam",
      "unit": "Piece"
    }
  ],
  "CONSERVATIVE DENTISTRY / RESTORATIONS": [
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "GIC Powder",
      "typeVariant": "Type II",
      "unit": "gram"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "GIC Liquid",
      "typeVariant": "Type II",
      "unit": "ml"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Mixing Pad",
      "typeVariant": "Paper",
      "unit": "Sheet"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Plastic Filling Instrument",
      "typeVariant": "Double Ended",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Matrix Band",
      "typeVariant": "Universal",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Wooden Wedge",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Bonding Agent",
      "typeVariant": "5th Generation",
      "unit": "ml"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Bonding Agent",
      "typeVariant": "7th Generation",
      "unit": "ml"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Etchant Gel",
      "typeVariant": "37% Phosphoric Acid",
      "unit": "ml"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Material",
      "typeVariant": "A1",
      "unit": "gram"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Material",
      "typeVariant": "A2",
      "unit": "gram"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Material",
      "typeVariant": "A3",
      "unit": "gram"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Material",
      "typeVariant": "A3.5",
      "unit": "gram"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Material",
      "typeVariant": "B1",
      "unit": "gram"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Material",
      "typeVariant": "B2",
      "unit": "gram"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Material",
      "typeVariant": "C2",
      "unit": "gram"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Material",
      "typeVariant": "Clear",
      "unit": "gram"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Material",
      "typeVariant": "Opaque",
      "unit": "gram"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Dispensing Tip",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Composite Dispensing Tip",
      "typeVariant": "Centrix",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Sectional Matrix",
      "typeVariant": "Contact Pro",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Matrix Retainer",
      "typeVariant": "Tofflemire",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Wedge",
      "typeVariant": "Wooden",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Wedge",
      "typeVariant": "Plastic",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Finishing Strip",
      "typeVariant": "Fine",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Finishing Strip",
      "typeVariant": "Coarse",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Polishing Point",
      "typeVariant": "Composite",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Polishing Point",
      "typeVariant": "Enamel",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Diamond Bur",
      "typeVariant": "Round FG",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Diamond Bur",
      "typeVariant": "Pear FG",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Diamond Bur",
      "typeVariant": "Flame FG",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Diamond Bur",
      "typeVariant": "Tapered FG",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Carbide Bur",
      "typeVariant": "Round FG",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Carbide Bur",
      "typeVariant": "Inverted Cone FG",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Carbide Bur",
      "typeVariant": "Fissure FG",
      "unit": "Piece"
    },
    {
      "domain": "CONSERVATIVE DENTISTRY / RESTORATIONS",
      "name": "Carbide Bur",
      "typeVariant": "Pear FG",
      "unit": "Piece"
    }
  ],
  "ENDODONTICS / ROOT CANAL": [
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Rubber Dam Sheet",
      "typeVariant": "Non-Latex",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Rubber Dam Sheet",
      "typeVariant": "Latex",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Rubber Dam Clamp",
      "typeVariant": "Anterior",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Rubber Dam Clamp",
      "typeVariant": "Molar",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Rubber Dam Frame",
      "typeVariant": "Plastic",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Rubber Dam Frame",
      "typeVariant": "Metal",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Local Anaesthetic Cartridge",
      "typeVariant": "Lignocaine 2%",
      "unit": "Cartridge"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Local Anaesthetic Cartridge",
      "typeVariant": "Articaine 4%",
      "unit": "Cartridge"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Needle",
      "typeVariant": "27G Long",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Needle",
      "typeVariant": "30G Short",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Sodium Hypochlorite",
      "typeVariant": "3.00%",
      "unit": "ml"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Sodium Hypochlorite",
      "typeVariant": "5.25%",
      "unit": "ml"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "EDTA Gel",
      "typeVariant": "17.00%",
      "unit": "ml"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "EDTA Solution",
      "typeVariant": "17.00%",
      "unit": "ml"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Saline Solution",
      "typeVariant": "Irrigation",
      "unit": "ml"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Paper Points",
      "typeVariant": "Size 20",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Paper Points",
      "typeVariant": "Size 25",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Paper Points",
      "typeVariant": "Size 30",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Paper Points",
      "typeVariant": "Size 35",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Paper Points",
      "typeVariant": "Size 40",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gutta Percha Points",
      "typeVariant": "Size 20",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gutta Percha Points",
      "typeVariant": "Size 25",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gutta Percha Points",
      "typeVariant": "Size 30",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gutta Percha Points",
      "typeVariant": "Size 35",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gutta Percha Points",
      "typeVariant": "Size 40",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Endo File Rotary",
      "typeVariant": ".04 Taper",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Endo File Rotary",
      "typeVariant": ".06 Taper",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Endo File Hand",
      "typeVariant": "K-File",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Endo File Hand",
      "typeVariant": "H-File",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Root Canal Sealer",
      "typeVariant": "Epoxy",
      "unit": "ml"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Root Canal Sealer",
      "typeVariant": "Silicone",
      "unit": "ml"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Temporary Filling",
      "typeVariant": "Cavit G",
      "unit": "gram"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Solvent",
      "typeVariant": "Chloroform",
      "unit": "ml"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Solvent",
      "typeVariant": "Endo Solvent R",
      "unit": "ml"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Retreatment Files",
      "typeVariant": "Special",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Post System",
      "typeVariant": "Fiber",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Post System",
      "typeVariant": "Metal",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Core Build-up Material",
      "typeVariant": "Opaque",
      "unit": "gram"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gates Glidden Drill",
      "typeVariant": "Size 1",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gates Glidden Drill",
      "typeVariant": "Size 2",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gates Glidden Drill",
      "typeVariant": "Size 3",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gates Glidden Drill",
      "typeVariant": "Size 4",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gates Glidden Drill",
      "typeVariant": "Size 5",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Gates Glidden Drill",
      "typeVariant": "Size 6",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Peeso Reamer",
      "typeVariant": "Size 1",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Peeso Reamer",
      "typeVariant": "Size 2",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Peeso Reamer",
      "typeVariant": "Size 3",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Peeso Reamer",
      "typeVariant": "Size 4",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Peeso Reamer",
      "typeVariant": "Size 5",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Peeso Reamer",
      "typeVariant": "Size 6",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Apex Locator Sleeve",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ENDODONTICS / ROOT CANAL",
      "name": "Endo Block",
      "typeVariant": "Standard",
      "unit": "Piece"
    }
  ],
  "ORAL SURGERY / EXTRACTIONS": [
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Sterile Gloves",
      "typeVariant": "Large",
      "unit": "Pair"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Sutures",
      "typeVariant": "3-0 PGA",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Sutures",
      "typeVariant": "4-0 PGA",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Sutures",
      "typeVariant": "3-0 Silk",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Elevator",
      "typeVariant": "Straight",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Elevator",
      "typeVariant": "Cryer",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Elevator",
      "typeVariant": "Potts",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Extraction Forceps",
      "typeVariant": "Universal Upper",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Extraction Forceps",
      "typeVariant": "Universal Lower",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Extraction Forceps",
      "typeVariant": "Anterior",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Extraction Forceps",
      "typeVariant": "Molar",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Gauze Pack",
      "typeVariant": "Pressure Dressing",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Betadine Solution",
      "typeVariant": "Standard",
      "unit": "ml"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Sterile Drapes",
      "typeVariant": "Small",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Sterile Drapes",
      "typeVariant": "Large",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Scalpel Blade",
      "typeVariant": "No. 15",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Scalpel Blade",
      "typeVariant": "No. 15C",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Surgical Suction Tip",
      "typeVariant": "Frazier",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Sterile Saline",
      "typeVariant": "50 mL",
      "unit": "Bottle"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Sterile Saline",
      "typeVariant": "100 mL",
      "unit": "Bottle"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Bone Graft",
      "typeVariant": "Bio-Oss",
      "unit": "gram"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Bone Graft",
      "typeVariant": "Hydroxyapatite",
      "unit": "gram"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Membrane",
      "typeVariant": "Collagen",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Membrane",
      "typeVariant": "PTFE",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Biopsy Container",
      "typeVariant": "With Formalin",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Surgical Stent",
      "typeVariant": "Custom",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Drain",
      "typeVariant": "Penrose",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Bone File",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Rongeur",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Chisel",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORAL SURGERY / EXTRACTIONS",
      "name": "Mallet",
      "typeVariant": "Standard",
      "unit": "Piece"
    }
  ],
  "PROSTHODONTICS / CROWNS & DENTURES": [
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Alginate Powder",
      "typeVariant": "Fast Set",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Alginate Powder",
      "typeVariant": "Regular Set",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Elastomeric Light Body",
      "typeVariant": "Polyvinyl Siloxane",
      "unit": "ml"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Elastomeric Light Body",
      "typeVariant": "Polyether",
      "unit": "ml"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Elastomeric Putty",
      "typeVariant": "Regular",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Tray Adhesive",
      "typeVariant": "For PVS",
      "unit": "ml"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Tray Adhesive",
      "typeVariant": "For Polyether",
      "unit": "ml"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Bite Registration Paste",
      "typeVariant": "Hard",
      "unit": "ml"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Bite Registration Paste",
      "typeVariant": "Soft",
      "unit": "ml"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Temporary Crown Material",
      "typeVariant": "Auto-mix",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Temporary Crown Material",
      "typeVariant": "Hand-mix",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Crown Cement",
      "typeVariant": "Resin-Modified GIC",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Crown Cement",
      "typeVariant": "Self-Adhesive Resin",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Disposable Crown Seat Syringe Tip",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Bridge Cement",
      "typeVariant": "Resin-Modified GIC",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Bridge Cement",
      "typeVariant": "Self-Adhesive Resin",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Denture Base Resin",
      "typeVariant": "Heat Cure",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Denture Base Resin",
      "typeVariant": "Cold Cure",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Acrylic Teeth",
      "typeVariant": "Anterior Set",
      "unit": "Set"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Acrylic Teeth",
      "typeVariant": "Posterior Set",
      "unit": "Set"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Pressure Indicating Paste",
      "typeVariant": "Standard",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Flexible Denture Material",
      "typeVariant": "Nylon-Based",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Wax Bite Rim",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Face Bow Transfer Kit",
      "typeVariant": "Disposable",
      "unit": "Kit"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Occlusal Indicator Wax",
      "typeVariant": "Standard",
      "unit": "gram"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Denture Cleaning Tablets",
      "typeVariant": "Standard",
      "unit": "Tablet"
    },
    {
      "domain": "PROSTHODONTICS / CROWNS & DENTURES",
      "name": "Denture Repair Kit",
      "typeVariant": "Standard",
      "unit": "Kit"
    }
  ],
  "ORTHODONTICS": [
    {
      "domain": "ORTHODONTICS",
      "name": "Metal Brackets Kit",
      "typeVariant": "MBT 0.22",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Metal Brackets Kit",
      "typeVariant": "Roth 0.22",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Metal Brackets Kit",
      "typeVariant": "Standard 0.22",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Ceramic Brackets Kit",
      "typeVariant": "Clear 0.22",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Ceramic Brackets Kit",
      "typeVariant": "Sapphire 0.22",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Self-Ligating Brackets Kit",
      "typeVariant": "Damon Q",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Self-Ligating Brackets Kit",
      "typeVariant": "Damon Clear",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Self-Ligating Brackets Kit",
      "typeVariant": "In-Ovation R",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Self-Ligating Brackets Kit",
      "typeVariant": "SmartClip",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Self-Ligating Brackets Kit",
      "typeVariant": "Quick",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Lingual Brackets Kit",
      "typeVariant": "Incognito",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Lingual Brackets Kit",
      "typeVariant": "STb",
      "unit": "Kit"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Functional Appliances",
      "typeVariant": "Twin Block",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Functional Appliances",
      "typeVariant": "Frankel",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Functional Appliances",
      "typeVariant": "Bionator",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Upper",
      "typeVariant": "Round 0.012",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Upper",
      "typeVariant": "Round 0.014",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Upper",
      "typeVariant": "Round 0.016",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Upper",
      "typeVariant": "Round 0.018",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Upper",
      "typeVariant": "Rectangular 0.016x0.022",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Upper",
      "typeVariant": "Rectangular 0.017x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Upper",
      "typeVariant": "Rectangular 0.019x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Lower",
      "typeVariant": "Round 0.012",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Lower",
      "typeVariant": "Round 0.014",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Lower",
      "typeVariant": "Round 0.016",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Lower",
      "typeVariant": "Round 0.018",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Lower",
      "typeVariant": "Rectangular 0.016x0.022",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Lower",
      "typeVariant": "Rectangular 0.017x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nickel Titanium Archwire Lower",
      "typeVariant": "Rectangular 0.019x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Upper",
      "typeVariant": "Round 0.016",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Upper",
      "typeVariant": "Round 0.018",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Upper",
      "typeVariant": "Round 0.020",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Upper",
      "typeVariant": "Rectangular 0.016x0.022",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Upper",
      "typeVariant": "Rectangular 0.017x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Upper",
      "typeVariant": "Rectangular 0.019x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Lower",
      "typeVariant": "Round 0.016",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Lower",
      "typeVariant": "Round 0.018",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Lower",
      "typeVariant": "Round 0.020",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Lower",
      "typeVariant": "Rectangular 0.016x0.022",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Lower",
      "typeVariant": "Rectangular 0.017x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Archwire Lower",
      "typeVariant": "Rectangular 0.019x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Beta Titanium Archwire (TMA) Upper",
      "typeVariant": "Round 0.016",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Beta Titanium Archwire (TMA) Upper",
      "typeVariant": "Round 0.018",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Beta Titanium Archwire (TMA) Upper",
      "typeVariant": "Rectangular 0.017x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Beta Titanium Archwire (TMA) Upper",
      "typeVariant": "Rectangular 0.019x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Beta Titanium Archwire (TMA) Lower",
      "typeVariant": "Round 0.016",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Beta Titanium Archwire (TMA) Lower",
      "typeVariant": "Round 0.018",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Beta Titanium Archwire (TMA) Lower",
      "typeVariant": "Rectangular 0.017x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Beta Titanium Archwire (TMA) Lower",
      "typeVariant": "Rectangular 0.019x0.025",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Copper NiTi Archwire Upper",
      "typeVariant": "0.012",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Copper NiTi Archwire Upper",
      "typeVariant": "0.014",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Copper NiTi Archwire Upper",
      "typeVariant": "0.016",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Copper NiTi Archwire Upper",
      "typeVariant": "0.018",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Copper NiTi Archwire Lower",
      "typeVariant": "0.012",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Copper NiTi Archwire Lower",
      "typeVariant": "0.014",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Copper NiTi Archwire Lower",
      "typeVariant": "0.016",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Copper NiTi Archwire Lower",
      "typeVariant": "0.018",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Elastic Modules",
      "typeVariant": "Grey",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Elastic Modules",
      "typeVariant": "Clear",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Elastic Modules",
      "typeVariant": "Silver",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Elastic Modules",
      "typeVariant": "Colored Assorted",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Ligatures",
      "typeVariant": "Short",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Ligatures",
      "typeVariant": "Medium",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Stainless Steel Ligatures",
      "typeVariant": "Long",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Power Chains",
      "typeVariant": "Short Continuous",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Power Chains",
      "typeVariant": "Medium Continuous",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Power Chains",
      "typeVariant": "Long Continuous",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Separators",
      "typeVariant": "Elastic",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Separators",
      "typeVariant": "Brass Wire",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Separator Pliers",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Mathieu Pliers",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Weingart Pliers",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Light Wire Pliers",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Bird Beak Pliers",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Howe Pliers",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Distal End Cutter",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Bracket Removing Pliers",
      "typeVariant": "Straight",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Bracket Removing Pliers",
      "typeVariant": "Curved",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Band Removing Pliers",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Molar Bands",
      "typeVariant": "Assorted Sizes",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Molar Bands",
      "typeVariant": "Upper First Molar",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Molar Bands",
      "typeVariant": "Lower First Molar",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Molar Bands",
      "typeVariant": "Upper Second Molar",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Molar Bands",
      "typeVariant": "Lower Second Molar",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Buccal Tubes",
      "typeVariant": "Single",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Buccal Tubes",
      "typeVariant": "Double",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Buccal Tubes",
      "typeVariant": "Triple",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Lingual Buttons",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Lingual Buttons",
      "typeVariant": "Double",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Lingual Buttons",
      "typeVariant": "Mesh Base",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Band Cement",
      "typeVariant": "Glass Ionomer",
      "unit": "gram"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Band Cement",
      "typeVariant": "Resin Modified",
      "unit": "gram"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Orthodontic Bonding Adhesive",
      "typeVariant": "Chemical Cure",
      "unit": "ml"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Orthodontic Bonding Adhesive",
      "typeVariant": "Light Cure",
      "unit": "ml"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Orthodontic Primer",
      "typeVariant": "Standard",
      "unit": "ml"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Orthodontic Primer",
      "typeVariant": "Self-Etching",
      "unit": "ml"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Orthodontic Etchant",
      "typeVariant": "37% Phosphoric Acid",
      "unit": "ml"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Bracket Adhesive Paste",
      "typeVariant": "Standard",
      "unit": "ml"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Bracket Adhesive Paste",
      "typeVariant": "High Strength",
      "unit": "ml"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Debonding Bur",
      "typeVariant": "Tungsten Carbide",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Debonding Bur",
      "typeVariant": "Diamond",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Adhesive Remover",
      "typeVariant": "Standard",
      "unit": "ml"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Adhesive Remover",
      "typeVariant": "Fluoridated",
      "unit": "ml"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Interarch Elastics",
      "typeVariant": "Light 1/8\"",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Interarch Elastics",
      "typeVariant": "Medium 3/16\"",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Interarch Elastics",
      "typeVariant": "Heavy 1/4\"",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Interarch Elastics",
      "typeVariant": "Class II",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Interarch Elastics",
      "typeVariant": "Class III",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Interarch Elastics",
      "typeVariant": "Vertical",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Coil Springs",
      "typeVariant": "Open 9mm",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Coil Springs",
      "typeVariant": "Open 12mm",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Coil Springs",
      "typeVariant": "Closed 9mm",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Coil Springs",
      "typeVariant": "Closed 12mm",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Push Springs",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Pull Springs",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Ligature Director",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Ligature Cutter",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Clear Aligner Trays",
      "typeVariant": "Basic Package",
      "unit": "Set"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Clear Aligner Trays",
      "typeVariant": "Premium Package",
      "unit": "Set"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Clear Aligner Trays",
      "typeVariant": "Invisalign Full",
      "unit": "Set"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Attachment Templates",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Attachment Templates",
      "typeVariant": "Premium",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Attachment Composite",
      "typeVariant": "Standard",
      "unit": "gram"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Attachment Composite",
      "typeVariant": "High Strength",
      "unit": "gram"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Chewies",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Aligner Case",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Aligner Cleaning Crystals",
      "typeVariant": "Standard",
      "unit": "gram"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Aligner Removal Tool",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Hawley Retainer",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Hawley Retainer",
      "typeVariant": "With Acrylic",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Clear Retainer",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Clear Retainer",
      "typeVariant": "Premium",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Fixed Retainer Wire",
      "typeVariant": "Braided 0.0175",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Fixed Retainer Wire",
      "typeVariant": "Braided 0.0215",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Fixed Retainer Wire",
      "typeVariant": "Solid 0.0175",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Fixed Retainer Bonding",
      "typeVariant": "Standard",
      "unit": "ml"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Retainer Case",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Retainer Box",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Transpalatal Arch (TPA)",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Nance Button",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Lingual Arch",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Quad Helix",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Rapid Palatal Expander",
      "typeVariant": "Hyrax",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Rapid Palatal Expander",
      "typeVariant": "Haas",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Headgear",
      "typeVariant": "Cervical",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Headgear",
      "typeVariant": "High Pull",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Headgear",
      "typeVariant": "Reverse Pull",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Face Mask",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Bite Plane",
      "typeVariant": "Anterior",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Bite Plane",
      "typeVariant": "Posterior",
      "unit": "Piece"
    },
    {
      "domain": "ORTHODONTICS",
      "name": "Positioner",
      "typeVariant": "Standard",
      "unit": "Piece"
    }
  ],
  "COSMETIC DENTISTRY": [
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Whitening Gel",
      "typeVariant": "10% Carbamide Peroxide",
      "unit": "ml"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Whitening Gel",
      "typeVariant": "16% Carbamide Peroxide",
      "unit": "ml"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Whitening Gel",
      "typeVariant": "35% Hydrogen Peroxide",
      "unit": "ml"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Cheek Retractor",
      "typeVariant": "Disposable",
      "unit": "Piece"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Desensitizing Gel",
      "typeVariant": "Post-Op",
      "unit": "ml"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Protective Eyewear",
      "typeVariant": "Patient",
      "unit": "Piece"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Laser Protective Eyewear",
      "typeVariant": "Specific Wavelength",
      "unit": "Piece"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Whitening Gel Syringes",
      "typeVariant": "Per Arch",
      "unit": "Syringe"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Custom Tray",
      "typeVariant": "Per Arch",
      "unit": "Piece"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Instructions Leaflet",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Adhesive Resin",
      "typeVariant": "Flowable",
      "unit": "ml"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Crystal/Gem",
      "typeVariant": "Clear",
      "unit": "Piece"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Crystal/Gem",
      "typeVariant": "Color",
      "unit": "Piece"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Veneer Cement",
      "typeVariant": "Clear",
      "unit": "ml"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Veneer Cement",
      "typeVariant": "Opaque",
      "unit": "ml"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Provisional Veneer Material",
      "typeVariant": "Bis-Acryl",
      "unit": "gram"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Impression Material",
      "typeVariant": "Putty",
      "unit": "gram"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Impression Material",
      "typeVariant": "Light Body",
      "unit": "ml"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Polishing Discs",
      "typeVariant": "Coarse",
      "unit": "Piece"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Polishing Discs",
      "typeVariant": "Medium",
      "unit": "Piece"
    },
    {
      "domain": "COSMETIC DENTISTRY",
      "name": "Polishing Discs",
      "typeVariant": "Fine",
      "unit": "Piece"
    }
  ],
  "IMPLANTOLOGY": [
    {
      "domain": "IMPLANTOLOGY",
      "name": "Implant",
      "typeVariant": "Standard 4.0mm",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Implant",
      "typeVariant": "Premium 4.0mm",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Healing Abutment",
      "typeVariant": "Titanium",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Cover Screw",
      "typeVariant": "Titanium",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Surgical Guide",
      "typeVariant": "Disposable",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Abutments",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Abutments",
      "typeVariant": "Premium",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Implant Surgical Kit",
      "typeVariant": "Sterile",
      "unit": "Kit"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Torque Wrench",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Healing Collar",
      "typeVariant": "Titanium",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Impression Coping",
      "typeVariant": "Open Tray",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Impression Coping",
      "typeVariant": "Closed Tray",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Lab Analog",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Surgical Stent",
      "typeVariant": "Custom",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Bone Condenser",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Depth Gauge",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "IMPLANTOLOGY",
      "name": "Tap Set",
      "typeVariant": "Standard",
      "unit": "Set"
    }
  ],
  "PEDIATRIC DENTISTRY": [
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Topical Anesthetic Gel",
      "typeVariant": "Flavored",
      "unit": "ml"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Sealant Material",
      "typeVariant": "Clear",
      "unit": "ml"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Sealant Material",
      "typeVariant": "Opaque",
      "unit": "ml"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Sealant Material",
      "typeVariant": "Fluoride Releasing",
      "unit": "ml"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Microbrush",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Pulpotomy Medicament",
      "typeVariant": "MTA",
      "unit": "gram"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Pulpotomy Medicament",
      "typeVariant": "Formocresol",
      "unit": "ml"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Stainless Steel Crown",
      "typeVariant": "Size 2",
      "unit": "Piece"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Stainless Steel Crown",
      "typeVariant": "Size 4",
      "unit": "Piece"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Stainless Steel Crown",
      "typeVariant": "Size 6",
      "unit": "Piece"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Glass Ionomer Temporary",
      "typeVariant": "Type I",
      "unit": "gram"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Cement for SSC",
      "typeVariant": "Glass Ionomer",
      "unit": "gram"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Crimping Pliers",
      "typeVariant": "Sterile",
      "unit": "Piece"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Disposable Tongue Depressor",
      "typeVariant": "Wooden",
      "unit": "Piece"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Pediatric Forceps",
      "typeVariant": "Small",
      "unit": "Piece"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Pediatric Mouth Prop",
      "typeVariant": "Standard",
      "unit": "Piece"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Behavior Management Stickers",
      "typeVariant": "Assorted",
      "unit": "Piece"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Fluoride Foam",
      "typeVariant": "Tray",
      "unit": "ml"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Space Maintainer",
      "typeVariant": "Band and Loop",
      "unit": "Piece"
    },
    {
      "domain": "PEDIATRIC DENTISTRY",
      "name": "Space Maintainer",
      "typeVariant": "Distal Shoe",
      "unit": "Piece"
    }
  ]
};
